import { List } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { DivisionListItem } from 'components/atoms/DivisionListItem';
import { Business } from 'models/Business';
import { memo, useMemo } from 'react';

interface Props {
  divisions: Business['divisions'];
  onCustomerSelect?: () => void;
}

export const DivisionList = memo(({ divisions, onCustomerSelect }: Props): JSX.Element => {
  const { xs, sm, md, lg, xl } = useBreakpoint();
  const isMobile = xs;

  // Determine the number of columns based on screen size
  const getColumnCount = useMemo(() => {
    if (xs) return 1;
    if (sm) return 2;
    if (md) return 3;
    if (lg) return 4;
    return 6; // xl and above
  }, [xs, sm, md, lg]);

  // Memoize the sorted divisions to prevent re-sorting on each render
  const sortedDivisions = useMemo(() => {
    return [...divisions].sort((a, b) => {
      let numA = parseInt(a.erpId.match(/\d+/)?.[0] || '0');
      let numB = parseInt(b.erpId.match(/\d+/)?.[0] || '0');
      return numA - numB;
    });
  }, [divisions]);

  return (
    <div
      style={{
        padding: isMobile ? '4px 4px' : '8px 8px',
        // backgroundColor: 'white',
        borderRadius: 8
        // boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)'
      }}>
      <List
        grid={{
          gutter: isMobile ? 8 : 16,
          xs: 1,
          sm: 2,
          md: 3,
          lg: 4,
          xl: 6,
          xxl: 6
        }}
        dataSource={sortedDivisions}
        renderItem={(division): JSX.Element => <DivisionListItem key={division.id} division={division} onCustomerSelect={onCustomerSelect} />}
        rowKey={(item): string => item.id}
      />
    </div>
  );
});
